// extracted by mini-css-extract-plugin
export default {"accountGrids":"accountGrids_accountGrids__zaaUG"};